export default __webpack_public_path__ + "static/media/card1.b2688570.png";